// Generated by `yarn tokens:import --aos-ds` from the Figma component set "Button/Attachment" (9312:187113). Do not edit.
//
// The "state" axis is interaction state, so it is not a prop: hover and hovered are `hover:`, pressed is `active:`, focus is `focus:`,
// and disabled is applied in JS because react-native-web renders a div, which
// Tailwind's `disabled:` never matches.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const buttonAttachmentContract = {
    component: 'Button/Attachment',
    nodeId: '9312:187113',
    section: '[Web] Primitives',
    // Components a variant instantiates, with the variant keys used.
    // Where one of these carries the component's own paint rather than
    // a glyph, the classes below describe only what is left — Checkbox
    // swaps a whole box here.
    composes: [{ component: 'Plus', variants: [] }],
    stateAxis: 'state',
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    textStyleIds: [
        'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
        'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
    ],
    props: {
        showFormatHint: { kind: 'boolean' },
    },
    variants: {
        default: {
            container:
                'bg-background-elevation border-border-subtle border rounded-common px-m py-m gap-xs w-[7.75rem] h-[7.75rem] items-center justify-center hover:border-border-strong',
            label: 'text-content-default text-left',
            icon: 'text-content-default',
            disabled: 'opacity-disabled',
            visited: '',
            box: '',
            parts: {
                'icon-label': 'gap-xs items-center',
                'option-label': 'text-content-default text-left',
                'format-hint': 'text-content-muted text-center',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'option-label': 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
                'format-hint': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [{ component: 'Plus', variants: [] }],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
